import { render } from "./CustomizeProduct.vue?vue&type=template&id=73cc8db3"
import script from "./CustomizeProduct.vue?vue&type=script&lang=js"
export * from "./CustomizeProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__